import * as React from "react";
const IconSupport = (props) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g opacity={0.4}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.9863 2.74243C8.42998 2.74243 4.73633 6.43608 4.73633 10.9924V13.7424H3.23633V10.9924C3.23633 5.60766 7.60155 1.24243 12.9863 1.24243C18.3711 1.24243 22.7363 5.60766 22.7363 10.9924V13.7424H21.2363V10.9924C21.2363 6.43608 17.5427 2.74243 12.9863 2.74243Z"
        fill={props.color || "#1C1C2C"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.9863 13.2424C22.4005 13.2424 22.7363 13.5782 22.7363 13.9924V15.9924C22.7363 19.7204 19.7143 22.7424 15.9863 22.7424H12.9863C12.5721 22.7424 12.2363 22.4066 12.2363 21.9924C12.2363 21.5782 12.5721 21.2424 12.9863 21.2424H15.9863C18.8858 21.2424 21.2363 18.8919 21.2363 15.9924V13.9924C21.2363 13.5782 21.5721 13.2424 21.9863 13.2424Z"
        fill={props.color || "#1C1C2C"}
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.2363 12.9924C15.2363 10.9214 16.9153 9.24243 18.9863 9.24243C21.0574 9.24243 22.7363 10.9214 22.7363 12.9924V14.9924C22.7363 17.0635 21.0574 18.7424 18.9863 18.7424C16.9153 18.7424 15.2363 17.0635 15.2363 14.9924V12.9924Z"
      fill={props.color || "#1C1C2C"}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.23633 12.9924C3.23633 10.9214 4.91526 9.24243 6.98633 9.24243C9.0574 9.24243 10.7363 10.9214 10.7363 12.9924V14.9924C10.7363 17.0635 9.0574 18.7424 6.98633 18.7424C4.91526 18.7424 3.23633 17.0635 3.23633 14.9924V12.9924Z"
      fill={props.color || "#1C1C2C"}
    />
  </svg>
);
export default IconSupport;
